import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.75 0.75L5.75 11.75L0.75 6.75",
		stroke: "#008500",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseCheck;
